<app-drawer-modal #drawerModal>
    <div content>
        <form [formGroup]="form">
            <div>
                <app-select [control]="form.get('motivo') | formControlConverter"
                            [options]="motivoOptions"
                            [label]="'Motivo' | translate"></app-select>
            </div>
            <div class="mt-md">
                <ion-input label="Email"
                           mode="md"
                           formControlName="email"
                           label-placement="floating"
                           fill="outline"></ion-input>
            </div>
            <div class="mt-md">
                <app-text-area [control]="form.get('message') | formControlConverter"
                               label="Messaggio"></app-text-area>
            </div>
            <p class="ts-small text-neutral-600">{{ 'inserisci_nel_messaggio' | translate }}</p>
        </form>
    </div>
    <div footer>
        <ion-button
                [disabled]="form.invalid || sendingMessage"
                (click)="onSend()" class="w-100 d-flex">
            <ion-spinner *ngIf="sendingMessage"
                         class="mr-sm" name="crescent"></ion-spinner>
            <span>{{ 'Invia' | translate }}</span>
        </ion-button>
    </div>
</app-drawer-modal>
<app-drawer-modal #confirmModal>
    <div class="d-flex flex-column ion-justify-content-center ion-align-items-center" content>

        <div>
            <ion-icon class="text-green-600 ts-h1"
                      name="checkmark-circle-outline"></ion-icon>
        </div>

        <div class="ts-body mt-sm">
            {{ 'Messaggio_inviato_con_syccesso' | translate }}
        </div>

        <div class="mt-md">
            <ion-button (click)="closeConfirmModal()"
                        class="w-100">{{ 'chiudi' | translate }}
            </ion-button>
        </div>

    </div>
</app-drawer-modal>
